<template lang="html">
    <DsDropdown
        icons
        position="bottom-end"
        data-qa="template-actions-menu-dropdown"
        disable-scroll
    >
        <template #default>
            <DsIconButton
                data-qa="template-actions-menu-btn"
                class="dropdown-button"
                name="more-vertical"
            />
        </template>

        <template #menu>
            <ul class="dropdown-menu-list">
                <li
                    class="option dropdown-menu-item"
                    data-qa="save-as-template-button"
                    @click="$emit('save-as-template')"
                >
                    <DsIcon name="templates" />

                    {{ $t('unlayerBuilder.templateSelection.menu.saveAsTemplate') }}
                </li>

                <li
                    class="option dropdown-menu-item"
                    data-qa="export-html-button"
                    @click="$emit('export-html')"
                >
                    <DsIcon name="download" />

                    {{ $t('unlayerBuilder.templateSelection.menu.exportHtml') }}
                </li>

                <li
                    class="option dropdown-menu-item"
                    data-qa="share-feedback-button"
                    @click="$emit('share-feedback')"
                >
                    <DsIcon name="message-square" />

                    {{ $t('unlayerBuilder.templateSelection.menu.shareFeedback') }}
                </li>

                <li
                    class="option dropdown-menu-item"
                    data-qa="send-test-email-button"
                    @click="$emit('send-test-email')"
                >
                    <DsIcon name="send" />

                    {{ $t('unlayerBuilder.templateSelection.menu.sendATest') }}
                </li>

                <li
                    v-if="showLearnMoreOption"
                    class="option dropdown-menu-item"
                    data-qa="learn-more-button"
                    @click="$emit('learn-more')"
                >
                    <DsIcon name="help-circle" />

                    {{ $t('global.learnMore.sentenceCase') }}
                </li>
            </ul>
        </template>
    </DsDropdown>
</template>

<script>
export default {
    props: {
        showLearnMoreOption: Boolean,
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.dropdown-button {
    display: flex;
    align-items: center;
    margin-right: $spacing-100;
}

.option {
    --icon-color: #{$color-ink-800};
    color: $color-ink-900;

    &.delete {
        --icon-color: #{$color-red-800};
        color: $color-red;
    }
}

.dropdown-menu-list {
    margin: 0;
}
</style>
